import React from 'react';
import { useToasts } from 'react-toast-notifications';

export const withToast = (Component) => (props) => {
    const toastFunctions = useToasts();
    return <Component {...props} {...toastFunctions} />;
};
